import React from 'react';
import { Pagination, Box } from '@mui/material';

const PaginationComponent = ({ page, count, onPageChange }) => {
    return (
        <Box display="flex" justifyContent="center" mt={3}>
            <Pagination
                count={count}
                page={page}
                onChange={(_, value) => onPageChange(value)}
                color="primary"
            />
        </Box>
    );
};

export default PaginationComponent;
